module.exports = __webpack_public_path__ + "static/media/id.f2bd9719.svg";